import apiClient from '@/services/api-client';
import store from '@/store/index';
import apiClientPost from '@/services/util/apiClientPost';
import { ERROR_DETAILS } from '../../constants/error-details';

export default {
	getProfile(organizationId = null, userId = null) {
		const endpoint = '/Profile/Get';
		const userIdCheck = userId;
		return apiClient()
			.get(endpoint, { params: { organizationId, userId } })
			.then(({ data }) => {
				store.dispatch('setUserProfile', data.userProfile);
				if (userIdCheck === null) {
					store.dispatch('setMainUser', data.userProfile);
				}
				store.dispatch('setCompanyProfile', data.companyProfile);
				store.dispatch('getAllDisclaimerLicenses', data.disclaimers);
				store.dispatch('getComplianceLogos', data.complianceLogos);
				store.dispatch('setRolePermission', data.rolePermissions);
				store.dispatch('setPrivileges', data.rolePrivileges);
				store.dispatch('setUserPermission', data.userPermissions);
				store.dispatch('setPartners', data.userPartners);
				store.dispatch('setInitialAddresses');
				const userId = data.userProfile.userId;
				store.dispatch('getAllPreferences', [userId]);
			})
			.catch((error) => {
				store.dispatch('showErrorModal', {
					error,
					errorDetails: ERROR_DETAILS.GET_PROFILE,
				});
			});
	},

	getOwnersByEntity() {
		const { entityId } = store.getters.currentUserRolodexIds;
		const endpoint = '/Lead/GetOwnersByEntity';

		if (entityId !== null) {
			return apiClient()
				.post(endpoint, { entityId })
				.then(({ data }) => {
					store.dispatch('setAllOwnersByEntity', data);
				})
				.catch((error) => {
					store.dispatch('showErrorModal', {
						error,
						errorDetails: ERROR_DETAILS.GET_OWNERS_BY_ENTITY,
					});
				});
		}
	},

	getProfileSelector(organizationId = null, userId = null) {
		const endpoint = '/Profile/GetProfileSelector';
		const userIdCheck = userId;

		return apiClient()
			.get(endpoint, { params: { organizationId, userId } })
			.then(({ data }) => {
				store.dispatch('setProfileSelector', data);
				if (userIdCheck === null) {
					store.dispatch('setMainBrokerShopDetails', data);
				}
			})
			.catch((error) => {
				store.dispatch('showErrorModal', {
					error,
					errorDetails: ERROR_DETAILS.GET_PROFILE_SELECTOR,
				});
			});
	},

	getUserBrokerDetails() {
		const endpoint = '/Profile/GetUsersBrokerDetails';
		return apiClient()
			.get(endpoint)
			.then(({ data }) => {
				store.dispatch('setBrokerShopDetails', data);
				if (userIdCheck === null) {
					store.dispatch('setMainBrokerShopDetails', data);
				}
			})
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}:\r ${error}`);
			});
	},

	getBrokerDetails(brokerId) {
		const endpoint = '/Profile/GetBrokerDetails';
		return apiClient()
			.get(endpoint, { params: { brokerId } })
			.then(({ data }) => {
				store.dispatch('setAeBrokerDetails', data);
			})
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}:\r ${error}`);
			});
	},

	getAllUsersByBrokerShop(organizationId) {
		const endpoint = '/Profile/GetAllUsers';
		return apiClient()
			.get(endpoint, { params: { organizationId } })
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}:\r ${error}`);
			});
	},

	saveUser(userProfile) {
		const endpoint = '/Profile/SaveUser';
		return apiClient()
			.post(endpoint, userProfile)
			.then(({ data }) => data);
	},

	async saveCompany(companyProfile) {
		const endpoint = '/Profile/SaveCompany';

		try {
			const response = await apiClientPost(endpoint, companyProfile);
			return Promise.resolve(response);
		} catch (error) {
			return Promise.reject(error);
		}
	},

	saveRolePermissions(orgId, rolePermissionList) {
		const endpoint = '/Profile/SavePermissions';

		let newRolePermissionList = rolePermissionList.flatMap((role) =>
			role.permissions.flatMap((category) =>
				category.permissions.map((permission) => ({
					role: role.role,
					permissionGroup: permission.group,
					isActive: permission.activeIndicator,
				})),
			),
		);

		const endpointRequestBody = {
			organizationId: orgId,
			rolePermissions: newRolePermissionList,
		};
		return apiClient()
			.post(endpoint, endpointRequestBody)
			.then(({ data }) => data)
			.catch((error) => {
				console.log(`${endpoint.toUpperCase()}: \r ${error}`);
			});
	},

	saveDisclaimers(disclaimers) {
		const endpoint = '/Profile/SaveDisclaimers';

		return apiClient()
			.post(endpoint, disclaimers)
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}: \r${error}`);
			});
	},

	saveComplianceLogos(complianceLogos) {
		return apiClient().post('/Profile/SaveComplianceLogos', complianceLogos);
	},

	getSearchToken() {
		const endpoint = '/Users/CoveoSearchToken';

		return apiClient()
			.get(endpoint)
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}:\r ${error}`);
			});
	},

	getAllPartners() {
		const endpoint = '/Users/GetAllPartners';

		return apiClient()
			.get(endpoint)
			.then(({ data }) => (data[0] && data[0].partners ? data[0].partners : []))
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}:\r ${error}`);
			});
	},

	savePartners(contactId, partner) {
		const endpoint = '/Users/SavePartners';

		return apiClient()
			.post(endpoint, {
				contactId,
				partner,
			})
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}: \r${error}`);
			});
	},

	resetUserRolodexModifiedFlag(userId) {
		const endpoint = '/Profile/ResetRolodexModifiedIndicator';
		const params = { userId };
		return apiClient()
			.post(endpoint, params)
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}: \r${error}`);
			});
	},

	async getVendorLink(userProfile) {
		const endpoint = '/Profile/SavePropertySearchProfile';

		return apiClient()
			.post(endpoint, userProfile)
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}: \r${error}`);
			});
	},

	async logUserSignIn() {
		const endpoint = '/Users/LogUserSignIn';
		return apiClient()
			.post(endpoint)
			.then(({ data }) => data)
			.catch((error) => {
				console.error(`${endpoint.toUpperCase()}: \r${error}`);
			});
	},

	async getUserHasVideoReviews(payload) {
		try {
			const response = await apiClientPost(
				`/VideoReview/UserHasVideos`,
				payload,
			);
			return Promise.resolve(response);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getADFSLink(payload) {
		try {
			const data = await apiClientPost('/videoreview/GetAdfsLink', payload);
			return Promise.resolve(data);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async updateSocialVAccount(payload) {
		try {
			const response = await apiClientPost(
				`/VideoReview/UpdateAccount`,
				payload,
			);
			return Promise.resolve(response);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async deleteAddress(payload) {
		try {
			const response = await apiClientPost(`/Profile/RemoveAddress`, payload);
			return Promise.resolve(response);
		} catch (error) {
			return Promise.reject(error);
		}
	},
};
